<template>
  <b-row
    v-if="tipoProposta === 'semchecklist'"
    align-v="baseline"
  >
    <b-col :cols="mostrar && !proposta.semContratante ? '10' : '12'">
      <b-form-group label="Informe o contratante para o financeiro">
        <validation-provider
          #default="{ errors }"
          :rules="mostrar || proposta.semContratante || getCheckOsConstituicao ? '': 'required'"
          name="Contratante"
        >
          <v-select
            id="tags-empresa"
            v-model="value_"
            :options="empresas"
            :multiple="false"
            :clearable="false"
            :label="'razaoSocial'"
            :placeholder="(proposta.semContratante) ? '' : 'Selecione a empresa contratante dessa proposta!'"
            :disabled="(proposta.semContratante) || (!pessoaSelecionada || !pessoaSelecionada.id || (propostaId > 0 && !mostrar && statusProposta !== 'naoaprovada' && statusProposta !== 'pendenteenvio') || (getCheckOsConstituicao && getStatusProposta !== 8))"
            @open="carregarEmpresas"
            @input="enviarParaPai"
          >

            <template #no-options>
              Não há empresas vinculadas ao cadastro de pessoas, verifique a informação!
            </template>
            <template #selected-option="{ cadastroFederal, razaoSocial, id }">
              <b-badge
                v-b-tooltip.hover.top
                title="Abrir cadastro em nova aba"
                style="cursor: pointer;"
                variant="primary"
                @click="abrirCadastroEmpresa(id)"
              >{{ cadastroFederal }} - {{ razaoSocial }}
              </b-badge>
            </template>
            <template v-slot:option="option">
              <div class="company-identification">
                <span>{{ option.cadastroFederal }}</span>
                <span
                  style="margin-left: 10px;"
                >{{ option.isMatriz? "Matriz" : "Filial" }}
                </span>
                <span
                  v-if="option.cidadeEEstado != null"
                  style="margin-left: 10px;"
                >{{ option.cidadeEEstado }}
                </span>
              </div>
              {{ option.razaoSocial }}
            </template>
          </v-select>
          <small
            v-if="errors[0] || obrigatorio"
            class="text-danger"
          >O campo Contratante(s) é obrigatório</small>
        </validation-provider>
      </b-form-group>
      <b-row>
        <b-col cols="4">
          <b-form-checkbox
            v-model="proposta.semContratante"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="disableEmpresaESemContrantante || disabledEmpresaSemContrantante"
            @change="selecaoSemContratante"
          >
            Sem empresa cadastrada no Hub Auditar
          </b-form-checkbox>
        </b-col>
        <b-col v-if="proposta.tipoProposta === 'semchecklist'">
          <b-form-checkbox
            v-model="proposta.contratantePessoaFisica"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="disableEmpresaESemContrantante || disabledEmpresaSemContrantante"
            @change="contratantePessoaFisica"
          >
          Selecionar empresa não vinculada ao contato
          </b-form-checkbox>
        </b-col>
        <b-col v-if="proposta.tipoProposta === 'semchecklist'">
          <b-form-checkbox
            v-model="osConstituicao"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="true"
          >
            O.S de constituição
          </b-form-checkbox>
        </b-col>
      </b-row>

    </b-col>
    <b-col
      v-if="mostrar && !proposta.semContratante"
      cols="auto"
    >
      <b-btn
        size="sm"
        variant="primary"
        @click="salvarEmpresas"
      >
        Salvar contratante(s)
      </b-btn>
    </b-col>

    <dados-contratante
      ref="dadosContrante"
      :value="proposta.propostaContratanteDetails"
      :proposta-id="proposta.id"
      :show-alteracao="proposta.propostaContratanteDetails === undefined ? false : true "
      @aprovar="salvarDadosContatante($event)"
    />
  </b-row>
</template>

<style lang="scss">
#tags-empresa ::placeholder {
  font-style: italic;
}

#tags-empresa .vs__dropdown-option--selected {
  & .company-identification span {
    color: #ffffff !important;
    background-color: transparent;
    border: 1px solid #ffffff !important;
  }
}

.company-identification {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.detail-check-contrantante-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-contrantante-sm.input-group-sm
  .custom-checkbox
  .custom-control-label::before {
  left: 0px !important;
}

.detail-check-contrantante-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label {
  font-size: 1rem !important;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { ValidationProvider } from 'vee-validate'
import pessoaApi from '@/app-modulo/comercial/pessoa/shared/services/api'
import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import { isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  name: 'EmpresaContratante',
  components: {
    vSelect,
    ValidationProvider,
    DadosContratante: () => import('../dados-contrantante-interno/DadosContratanteInterno.vue'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    tipoProposta: {
      type: String,
      default: '',
    },
    pessoa: {
      type: Object,
      default: null,
    },
    mostrarBotao: {
      type: Boolean,
      default: false,
    },
    statusProposta: {
      type: String,
      default: '',
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    proposta: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      valueAttr: null,
      empresas: [],
      pessoaSelecionada: null,
      mostrar: false,
      obrigatorio: false,
      propostaAtual: {},
      disabledByOsConstituicao: true,
      semContratanteCiente: false,
      disabledEmpresaSemContrantante: false,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao', 'getStatusProposta']),
    osConstituicao: {
      get() {
        return this.getCheckOsConstituicao
      },
      set(newValue) {
        this.setCheckOsConstituicao(newValue)
        return this.getCheckOsConstituicao
      },
    },
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    disableEmpresaESemContrantante() {
      return (this.getStatusProposta === 8 && this.proposta.semContratante && this.proposta.empresasVinculadas.some(s => s.empresaResumida?.id > 0))
        || (this.getStatusProposta === 8 && this.valueAttr && this.valueAttr.length > 0)
        || (this.getCheckOsConstituicao && this.getStatusProposta !== 8)
        || (!this.getCheckOsConstituicao && (!this.pessoaSelecionada || !this.pessoaSelecionada.id || (this.propostaId > 0 && this.statusProposta !== 'naoaprovada' && this.statusProposta !== 'pendenteenvio')))
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
    pessoa(val, oldValue) {
      if (val !== oldValue) {
        this.pessoaSelecionada = val
      }
    },
    mostrarBotao(val, oldVal) {
      if (val !== oldVal) {
        this.mostrar = val
      }
    },
    proposta(val, oldVal) {
      if (val !== oldVal) {
        this.propostaAtual = val
      }
    },
  },
  created() {
    this.pessoaSelecionada = this.pessoa
    this.mostrar = this.mostrarBotao
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    ...mapActions('listas', ['adicionarContratanteCapa']),
    ...mapActions('proposta', ['setCheckOsConstituicao']),

    carregarEmpresas() {
      if (this.proposta.contratantePessoaFisica) {
        this.carregarEmpresasPessoaFisica()
      } else {
        this.carregarEmpresasDoContato()
      }
    },
    carregarEmpresasDoContato() {
      if (this.pessoa) {
        pessoaApi.getEmpresasPessoa(this.pessoaSelecionada.id)
          .then(payload => {
            this.empresas = payload.data
          })
      }
    },
    // Esta função deve carregar apenas "empresas" com o tipo de inscrição 1 (pessoa Física)
    // Mas por motivos de urgencia, ela está carregando todas as empresas
    // Quando resolvido o problema, remover este comentário. Obrigado!
    carregarEmpresasPessoaFisica() {
      if (this.pessoa) {
        empresaApi.getEmpresasResumidas([{
          Colunas: ['TipoInscricao'],
          Valores: [1],
        }])
          .then(payload => {
            this.empresas = payload.data
          })
      }
    },
    enviarParaPai() {
      this.obrigatorio = false
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
      if (this.proposta.statusProposta === 'finalizada') {
        this.disabledEmpresaSemContrantante = true
      }
    },
    salvarEmpresas() {
      if (!this.value_ || this.value_.length === 0) {
        this.$erro('Informe os contratante(s)!')
      } else {
        this.$confirmar('Tem certeza que deseja salvar agora?', 'Ao confirmar a ação o sistema irá salvar o contratante e desabilitará o campo para alteração.', 'question', 'danger')
          .then(result => {
            if (result.value) {
              api.adicionarPropostaEmpresas(this.propostaId, this.value_)
                .then(payload => {
                  this.mostrar = false
                  this.obrigatorio = false
                  this.$sucesso('Salvo com sucesso!')
                  this.adicionarContratanteCapa({ propostaId: this.propostaId, contratante: payload.data })
                  this.$emit('salvo-contratante', this.value_)
                  this.$router.go()
                })
                .catch(err => {
                  this.$erro(err.response.data.message || err.message)
                  throw err
                })
            }
          })
      }
    },
    abrirCadastroEmpresa(value) {
      if (isAdmin()) {
        abrirEmNovaGuia('editar-emp', value)
      } else {
        const ability = permitidoAcessarRecurso('empresa')
        if (ability) {
          if (ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-emp', value)
          } else {
            abrirEmNovaGuia('empresas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    selecaoSemContratante(value) {
      if (value) {
        this.$atencao('Atenção', 'Esse parâmetro influência diretamente na integração dos dados do financeiro na Omie! Somente marque-o, nos casos em que a  empresa contratante não esteja cadastrada no Hub Auditar.', 'Ciente')
          .then(result => {
            if (result.value && this.proposta.tipoProposta === 'semchecklist' && this.proposta.statusProposta === 'finalizada') {
              this.$refs.dadosContrante.show()
            }
          })
        this.value_ = []
        this.$emit('remover-empresa')
      }
    },
    contratantePessoaFisica(value) {
      if (value) {
        if (this.proposta.tipoProposta === 'semchecklist' && this.proposta.statusProposta === 'finalizada') {
          this.$refs.dadosContrante.show()
        }
        this.value_ = []
        this.$emit('remover-empresa')
      }
    },
    salvarDadosContatante(value) {
      api.adicionarPropostaContratante(this.proposta.id, value)
        .then(payload => {
          this.proposta.propostaContratanteDetails = payload.data
          this.$sucesso('Dados do financeiro alterado com sucesso!')
          this.$router.go()
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
  },
}
</script>
